import $ from 'jquery';
require('./shared/layout');

// Contact form → Intercom handoff.
// Identifies the visitor (name + email), then opens the Intercom
// messenger with their message prefilled — one click to send.
// Falls back to a mailto: draft if Intercom never loads.
(function () {
  var form = $('#form_contact');

  if (!form.length) return;

  var btn = form.find('.cta_btn');
  var errorBox = $('#form_error');

  var setProcessing = function (state) {
    btn.toggleClass('processing', state);
    btn.attr('disabled', state);
  };

  var showError = function (message) {
    errorBox.text(message).show();
  };

  var clearError = function () {
    errorBox.hide().text('');
    form.find('.invalid').removeClass('invalid');
  };

  var validate = function (name, email, message) {
    if (!name) {
      $('#input_name').addClass('invalid').focus();
      return 'please enter your name.';
    }

    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      $('#input_uid').addClass('invalid').focus();
      return 'please enter a valid email address.';
    }

    if (!message) {
      $('#input_message').addClass('invalid').focus();
      return 'please enter a message.';
    }

    return null;
  };

  form.submit(function (event) {
    event.preventDefault();

    if (btn.hasClass('processing')) return;

    clearError();

    var name = $.trim($('#input_name').val());
    var email = $.trim($('#input_uid').val());
    var message = $.trim($('#input_message').val());

    var error = validate(name, email, message);

    if (error) {
      showError(error);
      return;
    }

    setProcessing(true);

    // attach identity to the Intercom visitor so the
    // conversation reaches us with name + email attributed
    if (window.Intercom) {
      window.Intercom('update', { name: name, email: email });
    }

    var composed = message + '\n\n— ' + name + ' (' + email + ')';

    var fallbackUrl =
      'mailto:support@livepush.io' +
      '?subject=' + encodeURIComponent('Contact request from ' + name) +
      '&body=' + encodeURIComponent(composed);

    // opens the messenger with the message prefilled;
    // retries while Intercom loads, then falls back to email draft
    window.openChat(composed, fallbackUrl);

    setTimeout(function () {
      setProcessing(false);
    }, 1500);
  });

  // clear field-level errors as the user types
  form.on('input', 'input, textarea', function () {
    $(this).removeClass('invalid');
  });
})();
